import styled from 'styled-components';
import { ITextAreaProps } from '../../../types/formTypes';

export const TextAreaWrapper = styled.div<Pick<ITextAreaProps, 'width' | 'height'>>`
  width: ${({ width }) => (width ? `${width}px;` : '100%;')};
  height: ${({ height }) => `${height}px;`};
`;

export const TextAreaLabel = styled.div<Pick<ITextAreaProps, 'darkMode'>>`
  margin-block: 0 15px;
  ${({ darkMode }) => (darkMode ? 'color: var(--base-color-white)' : '')};
`;

export const TextAreaBox = styled.textarea<Pick<ITextAreaProps, 'error' | 'darkMode'>>`
  font-family: var(--font-family-altHeader);
  font-feature-settings: var(--font-feature-settings-altHeader);
  font-size: var(--font-size-altHeader-6);
  font-weight: var(--font-weight-altHeader-6);
  box-sizing: border-box;
  resize: none;
  padding: 20px;
  width: 100%;
  height: 100%;
  border: 1px solid ${({ error }) => (!!error ? 'var(--base-color-errorstate)' : 'var(--base-color-lightgrey)')};

  ${({ error, darkMode }) => {
    if (!darkMode || !error) return;

    return 'outline: 3px solid var(--base-color-errorstate)';
  }};

  :disabled {
    background-color: var(--base-color-lightgrey);
    border: 1px solid transparent;
    outline: none;
  }

  :focus {
    outline-style: solid;
    outline-width: ${({ darkMode }) => (darkMode ? '4px' : '3px')};
    outline-color: ${({ darkMode }) => (darkMode ? 'var(--base-color-lemonchiffon)' : 'var(--base-color-lapislazuli)')};
  }
`;

export const TextAreaError = styled.div<Pick<ITextAreaProps, 'darkMode'>>`
  ${({ darkMode }) => (darkMode ? 'color: var(--base-color-white)' : '')};
  color: ${({ darkMode }) => (darkMode ? 'var(--base-color-white)' : 'var(--base-color-errorstate)')};
  margin-block: 15px 0;
`;
